import useSWR, { mutate } from "swr";
import axios from "axios";
import moment from "moment";

export function UseScalingActions() {
  // SWR: Retrieve Scaling Actions
  const { isValidating: SCALING_ACTIONS_LOADING, data: SCALING_ACTIONS } =
    useSWR(
      "/api/scaling",
      async (url) => await axios.get(url).then((res) => res.data)
      // { revalidateIfStale: false, revalidateOnFocus: false }
    );

  return {
    SCALING_ACTIONS_LOADING,
    SCALING_ACTIONS,
  };
}

export function CreateScalingActions(setAlert, username, actions) {
  // SWR: Append New Scaling Actions
  mutate("/api/scaling", async (SCALING_ACTIONS) => {
    // console.log("create scaling", username, actions);

    // Create Scaling Actions in Database
    const res = await axios.post("/api/scaling", {
      actions,
      username,
    });
    const new_actions = res.data;

    if (new_actions) {
      setAlert("Scaling Action Created.", "success");

      // Mutate SCALING_ACTIONS
      return [...SCALING_ACTIONS, ...new_actions];
    }
  });
}

export function UpdateScalingActions(
  setAlert,
  username,
  update_actions,
  delete_action_ids
) {
  // SWR: Update Specific Scaling Actions
  mutate("/api/scaling", async (SCALING_ACTIONS) => {
    // console.log("update scaling", username, update_actions, delete_action_ids);

    let return_actions = [...SCALING_ACTIONS];

    // Update Scaling Actions in Database
    if (update_actions.length > 0) {
      update_actions.forEach(async (action) => {
        action.updated_at = moment().format("YYYY-MM-DD HH:mm:ss");

        const res = await axios.put("/api/scaling", {
          action,
          username,
        });
        const new_action = res.data;

        const existing_actions = return_actions.filter(
          (action) => action.action_id !== res.data.action_id
        );

        return_actions = [...existing_actions, new_action];
      });
    }

    // Delete Scaling Actions in Database
    if (delete_action_ids.length > 0) {
      await axios.delete(
        `/api/scaling?action_ids=${JSON.stringify(
          delete_action_ids
        )}&username=${username}`
      );

      return_actions = return_actions.filter(
        (action) => !delete_action_ids.includes(action.action_id)
      );
    }

    setAlert("Scaling Action Updated.", "success");

    // Mutate SCALING_ACTIONS
    return return_actions;
  });
}
